exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group select[data-v-4d509311] {\n  text-align: left !important;\n  width: 100%;\n}\n.form-group label[data-v-4d509311]:first-of-type, .form-group select[data-v-4d509311] {\n  display: inline-block;\n  width: 45%;\n}\n.form-group select[data-v-4d509311] {\n  width: 50%;\n}\n", ""]);

// exports
